//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'RequestBoatModal',
  props: {
    buttonText: {
      type: String,
      default: 'request-offer'
    }
  },
  data () {
    return {
      busy: {
        button: false
      }
    }
  },
  created () {
    this.$nuxt.$on('request-modal__loading', (event) => {
      this.busy.button = !!event?.state
    })
  }
}
